import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Progress, notification, Divider, Switch, Space } from 'antd';
import {MongoQueryBuilder} from "../../../utils/mongoQuery";
import {fetchFilteredTickers} from "../../../Api/tickersApi";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import NivoTreeChart from "../../../charts/nivo/NivoTreeChart";
import {stringMixin} from "../../../utils/strings";
import {getRandomColor} from "../../../utils/colorUtils";


const calculateTotalWeight = (items) => {
    return items.reduce((acc, item) => acc + parseFloat(item.wgt || 0), 0);
};



const formatQueryOnStyleboxSelect = (selectedStyle) => {
    let mongoQuery = new MongoQueryBuilder();
    let [sizes, styles] = [[], []];
    let [size, style] = selectedStyle.split('_');
    if (!sizes.includes(size)) sizes.push(size);
    if (!styles.includes(style)) styles.push(style);
    mongoQuery.addCondition({fullPath: 'type', value: 'etf', operator: 'eq'})
    mongoQuery.inList('tags.style', styles)
    mongoQuery.inList('tags.size', sizes)
    mongoQuery.setLimit(20);
    mongoQuery.setSort({'specs.aum': -1});
    mongoQuery.updateProjection(['name', 'symbol', 'logo', 'type'])
    return mongoQuery;
}


const BuilderPanel = ({ items, onTickerSubmit, disableSider }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const tickersData = useSelector((state) => state.tickers.filteredTickers);
  const totalWeight = calculateTotalWeight(items);

  const handleStyleboxSelect = (selectedStyle) => {
    const mongoQuery = formatQueryOnStyleboxSelect(selectedStyle);
    dispatch(fetchFilteredTickers(mongoQuery.toMongoQuery()));
    setIsModalVisible(true);
    setModalTitle(`Select Tickers for ${stringMixin.fmt(selectedStyle)}`);
  }

  useEffect(() => {
    if (totalWeight > 101) {
      notification.error({
        message: 'Total Weight Exceeded',
        description: 'The total weight of all items exceeds 100%. Please adjust the weights accordingly.',
        duration: 0, // Duration set to 0 will make the notification stay until the user closes it manually.
      });
    }
  }, [totalWeight]);

  const handleTickerSubmit = (selectedTickers) => {
      console.log(selectedTickers)
    if (selectedTickers.length > 0) {
        onTickerSubmit(selectedTickers);
    }
    setIsModalVisible(false); // Close the modal
  };

  const pieData = items.map(item => ({ id: item.name, value: item.wgt }));
  const treeData = {name: "Portfolio", children: items.map(x=>{
      return {name: x.name, value: x?.wgt?.toFixed(1) ?? 0, color: getRandomColor()}
      })};

  return (
      <Space direction={'vertical'}>
          {disableSider&&(
              <Switch defaultChecked={true} onClick={disableSider} checkedChildren={'Close Results Panel'}/>
          )}
          <Divider/>
          <Progress
                percent={Math.min(100, totalWeight)} // Cap the progress at 100% to prevent overflow in the UI
                strokeColor={totalWeight < 90 ? '#F78484' : '#0CE89F'}
                size={[335, 30]}
                percentPosition={{
                        align: 'start',
                        type: 'inner'
                }}
              format={(pct)=><span style={{color:'#fff', fontWeight: '600', marginLeft: '10px'}}> {pct.toFixed(0)}% Filled</span>}
              strokeLinecap={'butt'}
          />
          <Divider/>
          <div style={{height: 300, width: '100%', border: 'none'}}>
              {items.length < 15 ? <NivoTreeChart showToolbar={false} marginX={0} data={treeData} initialMode={'slice'} nodeOpacity={1} /> : <NivoPieChart data={pieData} radius={0.5} showLabels={false}/>}
          </div>
      </Space>
  );
};

export default BuilderPanel;
